import { useMemo } from 'react'
import AcrossTabs from 'across-tabs'
import { useSelector, useDispatch } from 'react-redux'
import getUrlParams from 'utils/bomUtils'
import { actionSetStakeData, actionSetStatus } from 'redux/staking/reducer'

export const useConnectStaking = () => {
  const { address } = useSelector(state => state?.account)
  const dispatch = useDispatch()
  const isFromStaking = getUrlParams('staking')
  const child = useMemo(() => {
    const onReady = params => {
      console.log('onReady')
      console.log(params)
    }

    const onInitialize = params => {
      console.log('initialize')
      console.log(params)
    }

    const onParentDisconnect = () => {
      console.log('onParentDisconnect')
    }

    const onParentCommunication = params => {
      if (params.type === 'request_address') {
        child.sendMessageToParent({ type: 'unlock_success', address })
      }

      if (params.type === 'redelegate') {
        dispatch(actionSetStakeData({ ...params }))
        dispatch(actionSetStatus(params.type))
      } else {
        const { delegatorAddress, validatorAddress, amount, type, validatorName } = params
        dispatch(actionSetStakeData({ delegatorAddress, validatorAddress, amount, validatorName }))
        dispatch(actionSetStatus(type))
      }
    }

    const config = {
      onReady,
      onInitialize,
      isSiteInsideFrame: false, // dont set if not required
      handshakeExpiryLimit: 4000, // msec
      onParentDisconnect,
      onParentCommunication,
    }

    if (!isFromStaking) {
      return {}
    }
    return new AcrossTabs.Child(config)
  }, [isFromStaking, address, dispatch])

  return child
}
